module.exports = __webpack_public_path__ + "static/mailbox-mobile-c8012855fe9b42c1266bcc97a381fa95.png";